const anchorManagement = () => {
    // Sélection des liens externes et document
    document.querySelectorAll('a.external, a.document').forEach(link => {
        // Ajout de l'attribut target="_blank"
        link.setAttribute('target', '_blank');
        let title = link.getAttribute('title');
        if (title === null) {
            // Clonage de l'élément pour traiter le texte
            const clonedLink = link.cloneNode(true);
            // Suppression des éléments avec aria-hidden="true"
            clonedLink.querySelectorAll('[aria-hidden="true"]').forEach(ariaHiddenElement => {
                ariaHiddenElement.remove();
            });

            // Récupération du texte
            title = clonedLink.textContent.trim();

            // Si le texte est vide, vérifier les balises <img> pour utiliser l'alt
            if (title === '') {
                const img = link.querySelector('img');
                if (img) {
                    title = img.getAttribute('alt') ? img.getAttribute('alt').trim() : '';
                }
            }
        }

        if (title !== '') {
            // Ajout des informations au titre pour les liens externes ou documents
            if (link.classList.contains('external')) {
                title += ' ' + cmsCore.title_newwindow;
            } else if (link.dataset.file_ext !== undefined) {
                title += ' (' + link.dataset.file_ext;
                if (link.dataset.file_weight !== undefined) {
                    let size = parseInt(link.dataset.file_weight, 10);
                    size = size < 1000000
                        ? `${Math.round((size / Math.pow(2, 10)) * 100) / 100} Ko`
                        : `${Math.round((size / Math.pow(2, 20)) * 100) / 100} Mo`;
                    title += ` - ${size}`;
                }
                title += ')';
            }

            // Nettoyage des espaces multiples et attribution du titre final
            link.setAttribute('title', title.replace(/\s+/g, ' '));
        }
    });
}

document.addEventListener('DOMContentLoaded', anchorManagement);
